import { AxiosResponse, AxiosError } from 'axios';
import { useMutation, UseMutationResult } from 'react-query';
import { ErrorMessage, Phone } from 'types';
import { client } from 'utils/api-client';

function useSendSMSOTP(): UseMutationResult<AxiosResponse<null>, AxiosError<ErrorMessage>, Phone> {
  return useMutation(request => client.post('auth/send-sms-otp/', request));
}

export default useSendSMSOTP;
